import React from "react";
import AllProducts from "./AllProducts";
import Cart from "./Cart";

const Container = ({ children }) => {
  return (
    <div className='grid grid-cols-12 gap-6'>
      <AllProducts />
      <Cart />
    </div>
  );
};

export default Container;
